"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mapper = void 0;
var react_1 = __importDefault(require("react"));
function Mapper(props) {
    var _a = props.data, data = _a === void 0 ? [] : _a, Item = props.renderItem, _b = props.keyExtractor, keyExtractor = _b === void 0 ? function (item, index) { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index); } : _b, _c = props.itemProps, itemProps = _c === void 0 ? {} : _c, _d = props.separator, separator = _d === void 0 ? null : _d;
    if (!data || !Array.isArray(data))
        return null;
    return react_1.default.createElement(react_1.default.Fragment, null, data === null || data === void 0 ? void 0 : data.map(function (item, index, arr) {
        var key = keyExtractor(item, index);
        return react_1.default.createElement(react_1.default.Fragment, null,
            index == 0 ? null : separator,
            react_1.default.createElement(Item, __assign({ key: key, item: item, index: index, isFirst: index == 0, isLast: index == (arr === null || arr === void 0 ? void 0 : arr.length) - 1 }, itemProps)));
    }));
}
exports.Mapper = Mapper;
